import { ActivityCore } from '../models/activity-core';

export class ActivityUtils {
  public static sortActivitiesByOrder<T extends ActivityCore>(activities: T[], activityOrder: string[]): T[] {
    if (!activityOrder || activityOrder.length === 0) {
      return activities ?? [];
    }

    const safeActivities = activities ?? [];
    const activityMap = new Map(safeActivities.map((activity: T) => [activity.activityId, activity]));
    const sorted: T[] = [];
    const processedIds = new Set<string>();

    for (const id of activityOrder) {
      if (processedIds.has(id)) continue;
      const activity = activityMap.get(id);
      if (activity) {
        sorted.push(activity);
        processedIds.add(id);
      }
    }

    for (const activity of safeActivities) {
      if (!processedIds.has(activity.activityId)) {
        sorted.push(activity);
      }
    }
    return sorted;
  }
}
